import { CHANGE_VIEW } from '../constants'
import { createAction, handleActions } from 'redux-actions'

// ACTION CREATORS
export const changeView = createAction(CHANGE_VIEW)

// REDUCERS
export default handleActions(
  {
    CHANGE_VIEW: (state) => {
      if (state === 0) return 1
      return 0
    }
  },
  0
)



// WEBPACK FOOTER //
// ./src/ducks/view.ts